import { render, staticRenderFns } from "./LegalReplyBox.vue?vue&type=template&id=2e3fbe3e&scoped=true&"
import script from "./LegalReplyBox.js?vue&type=script&lang=js&"
export * from "./LegalReplyBox.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3fbe3e",
  null
  
)

export default component.exports